import React from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import {addToContactSwitch} from '../../../../../../../../../actions/sharingDetailsActions';

class AddToContact extends React.Component {

	constructor(props) {
		super(props);

		this.addToContactHandler = this.addToContactHandler.bind(this);
	}

	addToContactHandler(){
		if (document.getElementById('addToContact').checked){
			this.props.setAddToContactSwitch(true);
		} else {
			this.props.setAddToContactSwitch(false);
		}
	}

	render() {
		return (
			<div className="custom-control custom-checkbox mr-sm-2 mb-1">
				<input type="checkbox" className="custom-control-input" id="addToContact" defaultChecked={true} onChange={this.addToContactHandler}/>
				<label className="custom-control-label" htmlFor="addToContact">
					{this.props.t("popupSharingSync")}
				</label>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
    return {
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
    };
};

const mapDispatchToProps = (dispatch) => {
	return {
		setAddToContactSwitch : (array) => {
			dispatch(addToContactSwitch(array))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AddToContact));
